export enum AppInsightPage {
  LANDING_PAGE = 'Landing page',
  ALL_CATEGORY_SWAP = 'All category swap',
  DETAIL_PAGE = 'Detail page',
  PRODUCTS_PAGE = 'Products page',
  SKU_SWAP_PAGE = 'SKU swap page',
}
